import { render, staticRenderFns } from "./IconIndustry.vue?vue&type=template&id=5b412e43&"
import script from "./IconIndustry.vue?vue&type=script&lang=ts&"
export * from "./IconIndustry.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports